import { createSlice } from "@reduxjs/toolkit";

export const homePageSlice = createSlice({
  name: "homePageSlice",
  initialState: {
    isLoading: false,
    isError: false,
    homePageData: {},
    message: "",
  },
  reducers: {
    onLandingHome: (state) => {
      return {
        ...state,
        isgetLoading: true,
        homePageData: {},
        getmessage: "",
      };
    },

    onLandingHomeSuccess: (state, { payload }) => {
      const { data = {}, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isgetLoading: false,
        homePageData: data,
        getmessage: message,
        status_code: status_code,
        data_updated: false,
        post_login_success: false,
        customeLoader: true, // Reset custom loader state
      };
    },

    onLandingHomeError: (state, { payload }) => {
      const { data = {}, message = "", status_code = 400 } = payload;
      return {
        ...state,
        homePageData: data,
        getmessage: message,
        status_code: status_code,
        isgetLoading: false,
      };
    },

    onLandingHomePostLogin: (state) => {
      // You can access the current state value directly via the 'state' parameter.
      // For example, to log the last state value:
      sessionStorage.removeItem("apiCallDone");
      return {
        ...state,
        isPostLoginLoading: true,
        getmessage: "",
        post_login_success: false, // Indicate that post-login action was successful
        data_updated: true,
        customeLoader: true, // Reset custom loader state
      };
    },

    onLandingHomePostLoginSuccess: (state, { payload }) => {
      const { data = {}, message = "", status_code = 200 } = payload;
      if ((data && data?.sectionMasters?.length > 0) || (data && (data?.sectionMasters === null || data?.sectionMasters?.length === 0))) {
        const persistedData = JSON.parse(sessionStorage.getItem('persist:root'));
        const homepageOldData = JSON.parse(persistedData?.homePageSliceReducer) || [];
        let newSectionMaster = homepageOldData?.homePageData?.sectionMasters.filter(item => item?.segmentId === null);
        let newSectionContentMasters = homepageOldData?.homePageData?.sectionContentMasters.filter(item => item?.segmentId === null && !item?.isPreLoginContent);
        let newDealCoupouns = homepageOldData?.homePageData?.dealCoupouns.filter(item => item?.segmentId === null && item?.cardCodes === null);
        // Get all id's from data?.sectionMasters
        const sectionMasterIds = data?.sectionMasters?.filter(item => item?.sectionType === "Unlock Deals").map(item => item?.id) || [];
        // Remove all matching id's from newSectionContentMasters based on sectionMasterId
        const sectionMasterIdSet = new Set(sectionMasterIds);
        newSectionContentMasters = newSectionContentMasters?.filter(item =>
          !sectionMasterIdSet?.has(item?.sectionMasterId)
        );
        const mergeById = (oldArray = [], newArray = []) => {
          if (newArray !== null) {
            const map = new Map();
            [...oldArray, ...newArray].forEach(item => {
              if (item?.id !== undefined) {
                map.set(item.id, item);
              }
            });
            return Array.from(map.values());
          } else {
            return oldArray;
          }
        };

        const newHomePageData = {
          dealCategories: mergeById(homepageOldData?.homePageData?.dealCategories, data?.dealCategories),
          dealCoupounFrequencies: mergeById(homepageOldData?.homePageData?.dealCoupounFrequencies, data?.dealCoupounFrequencies),
          dealCoupouns: mergeById(newDealCoupouns, data?.dealCoupouns),
          deals: mergeById(homepageOldData?.homePageData?.deals, data?.deals),
          navConfigures: mergeById(homepageOldData?.homePageData?.navConfigures, data?.navConfigures), // no new data
          productContents: mergeById(homepageOldData?.homePageData?.productContents, data?.productContents),
          sectionContentMasters: mergeById(newSectionContentMasters, data?.sectionContentMasters),
          sectionMasters: mergeById(newSectionMaster, data?.sectionMasters),
          segmentMappings: data?.segmentMappings,
          unlockSectionActivities: data?.unlockSectionActivities,
          themeManagement: homepageOldData?.homePageData?.themeManagement || data?.themeManagement,
          // hasSeenSiteTour: data?.hasSeenSiteTour,
          isVouchersHistory: data?.isVouchersHistory,
          siteTour: data?.siteTour
        };

        return {
          ...state,
          isPostLoginLoading: false,
          homePageData: newHomePageData,
          getmessage: message,
          status_code: status_code,
          data_updated: true, // Indicate that data has been updated
          post_login_success: true, // Indicate that post-login action was successful
          customeLoader: false, // Reset custom loader state
        };
      }
    },

    onLandingHomePostLoginError: (state, { payload }) => {
      const { data = {}, message = "", status_code = 400 } = payload;
      return {
        ...state,
        homePageData: data,
        getmessage: message,
        get_status_code: status_code,
        isgetLoading: false,
      };
    },
    // onClearHomePageTourData: (state) => {
    //   const updatedHomePageData = {
    //     ...state.homePageData,
    //     hasSeenSiteTour: true,
    //   };
    //   return {
    //     ...state,
    //     homePageData: updatedHomePageData,
    //   };
    // },
  }
});
export const {
  onLandingHome,
  onLandingHomeSuccess,
  onLandingHomeError,
  onLandingHomePostLogin,
  onLandingHomePostLoginSuccess,
  onLandingHomePostLoginError,
  // onClearHomePageTourData
} = homePageSlice.actions;

export default homePageSlice.reducer;
